var collapsible_list_component_rtlignore_default = {
  "ltr": "-NVRL",
  "rtl": "hiohq",
  "iconContainer": "aqRY0",
  "icon": "ir-ot",
  "isExpanded": "LEGEw",
  "listDimensions": "TCZER"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
